import styled from "styled-components";

export const Wrapper = styled.div`
    background-color: #dadbde;
    text-align: center;
    text-transform: uppercase;
    font-family: ${globalThis.config.fonts.families.bold};
    font-size: ${globalThis.config.fonts.sizes.xxsmall};
    color: ${globalThis.config.colors.black};
    height: 0.9rem;
    padding: 0 0.3rem;
    width: auto;
    border-radius: 0.1rem;
    ${(props) =>
        props.circle &&
        `
        border-radius: 1rem;
    `}
`;
